import { defineStore } from 'pinia';
import api from '@/services/api';
import {
  initial_proposal,
  initial_proposals_filters,
} from './proposals_model';
import { getParamsUrl } from './proposals_utils';

export const useProposalsStore = defineStore('proposalsStore', {
  state: () => ({
    proposal: JSON.parse(JSON.stringify(initial_proposal)),
    proposals: [],
    filters: JSON.parse(JSON.stringify(initial_proposals_filters)),
    roleFilters: {},
    page: 1,
    isOpenDrawerSelection: false,
    isLoading: false,
  }),
  getters: {},
  actions: {
    async findAllProposalsHTTP() {
      const result = await api.get(
        `/propuesta?${getParamsUrl({ ...this.filters, ...this.roleFilters, page: +this.page })}`,
      );
      if (result && result.data && result.data.length > 0) {
        this.proposals.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findProposalByCodigoHTTP(codigo) {
      try {
        const result = await api.get(`/propuesta/${codigo}`);
        if (result && result.data) {
          this.proposal = result.data;
        }
      } catch (error) {
        console.error('Error en proposal findProposalsByCodigoHTTP:', error);
      }
    },
    async saveProposal() {
      if (this.proposal.Codigo > 0) {
        await this.updateProposalHTTP();
      } else {
        await this.createProposalHTTP();
      }
    },
    async createProposalFromCotizacionHTTP(prePropuesta) {
      return await api.post(`/propuesta/fromCotizacion`, {
        Codigo: prePropuesta[0].CodigoCotizacion,
        CotizacionCantidad: prePropuesta.map((i) => i.Codigo),
      });
    },
    async createProposalHTTP() {
      const { PropuestaCotizacionCantidad, ...proposal } = this.proposal;

      const items = [];
      PropuestaCotizacionCantidad.forEach((cotizacion) => {
        cotizacion.items.forEach((item) => {
          items.push({
            CodigoPropuesta: proposal.Codigo,
            CodigoCotizacionCantidad: item.CodigoCotizacionCantidad,
          });
        });
      });

      proposal.PropuestaCotizacionCantidad = items;

      const result = await api.post(`/propuesta`, proposal);
      this.proposal.Codigo = result.data.Codigo;
    },
    async updateProposalHTTP() {
      const { PropuestaCotizacionCantidad, ...proposal } = this.proposal;

      const items = [];
      PropuestaCotizacionCantidad.forEach((cotizacion) => {
        cotizacion.items.forEach((item) => {
          items.push({
            CodigoPropuesta: proposal.Codigo,
            CodigoCotizacionCantidad: item.CodigoCotizacionCantidad,
          });
        });
      });

      proposal.PropuestaCotizacionCantidad = items;
      await api.patch(`/propuesta/${this.proposal.Codigo}`, proposal);
    },
    async approveCotizacionHTTP(payload) {
      await api.patch(`/propuesta/${this.proposal.Codigo}/approve`, payload);
    },
    setPage(page) {
      this.page = page;
    },
    emptyProposals() {
      this.proposals = [];
    },
    setFilters(newFilters) {
      this.filters = {
        ...(this.filters ?? {}),
        ...(newFilters ?? {}),
      };
    },
    resetFilters() {
      this.filters = structuredClone(initial_proposals_filters);
    },
    setRoleFilters(newFilters) {
      this.roleFilters = { ...(newFilters ?? {}) };
    },
    resetProposal() {
      this.proposal = JSON.parse(JSON.stringify(initial_proposal));
    },
    async firstRequest() {
      this.setPage(1);
      this.emptyProposals();
      await this.findAllProposalsHTTP();
    },
  },
});
